import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Flex,
  Form,
  FormContext,
  IInputProps,
  Text,
} from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

import AverageUnitValueInput from './components/AverageUnitValueInput';
import { FlexWraper } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/components/InventoryInfo/InventoryInfo.style';

const InventoryInfo = (props: IInputProps) => {
  const { t } = useTranslation('forms');
  const { stateHandlers, formState, formErrors } = useContext(FormContext);
  const validate = useValidation();

  const handleValue =
    (field: FormFields) => (e: { target: { value: string } }) => {
      stateHandlers[field](e.target.value);
      validate(field, e.target.value);
    };

  return (
    <Box mt={4}>
      <Text semibold lg>
        {t('labels.inventoryInfo')}
      </Text>
      <FlexWraper>
        <Flex flex={1} mr={2}>
          <Form.Group mt={4} w="100%">
            <Form.Label>{t('labels.defaultInventoryDetails')}</Form.Label>
            <Form.Input
              value={formState[FormFields.DefaultInventoryDetails] || ''}
              onChange={handleValue(FormFields.DefaultInventoryDetails)}
              placeholder={t('placeholders.defaultInventoryPlaceholder') || ''}
              $errorType={formErrors[FormFields.DefaultInventoryDetails]?.type}
              {...props}
            />
            <Form.Feedback
              $errorType={formErrors[FormFields.DefaultInventoryDetails]?.type}
            >
              {formErrors[FormFields.DefaultInventoryDetails]?.message}
            </Form.Feedback>
          </Form.Group>
        </Flex>
        <Flex flex={1} mr={2}>
          <AverageUnitValueInput
            fieldKey="bedrooms"
            disabled={props.disabled}
          />
        </Flex>
        <AverageUnitValueInput fieldKey="bathrooms" disabled={props.disabled} />
      </FlexWraper>
    </Box>
  );
};

export default InventoryInfo;
